import SelectItems from './SelectItems.vue'

export { SelectItems }
export default SelectItems
